module.exports = __webpack_public_path__ + "media/images/creator/home/kv-bg@2x-3025d12b372f79ffd8ebbb3a7170fd51.png";